import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ThreeDTab = ({ virtualTourUrl }) => {
  return (
    <div className={styles.wrapper}>
      <iframe src={virtualTourUrl} title={virtualTourUrl} height="100%" width="100%" />
    </div>
  );
};

ThreeDTab.propTypes = {
  virtualTourUrl: PropTypes.string,
};

export default ThreeDTab;
